import { IPageInfo } from '@/interfaces/common.model';
import {
  setDateFilter,
  setUpdateFilterStates,
} from '@/redux/features/UserSlice';
import moment from 'moment';
import { ChangeEvent, useRef } from 'react';
import { useDispatch } from 'react-redux';

export interface IBasePageStates extends IPageInfo {
  count?: number;
  searchQuery?: string;
}
const useFilter = <T extends IBasePageStates>(
  pageStates: T,
  setPageStates: React.Dispatch<React.SetStateAction<T>>,
) => {
  const dispatch = useDispatch();
  const timeoutId = useRef<NodeJS.Timeout | null>(null);
  const updateCurrentPage = () => {
    if ('currentPage' in pageStates) {
      setPageStates((prev) => ({
        ...prev,
        currentPage: 1,
      }));
    }
  };
  const pageChangeHandler = (PageNo: number) => {
    if (PageNo > 0 && PageNo <= pageStates?.totalPages) {
      setPageStates((prev) => ({
        ...prev,
        currentPage: PageNo,
      }));
      dispatch(setUpdateFilterStates({ currentPage: PageNo }));
    }
  };
  const orderByHandler = (e: ChangeEvent<HTMLSelectElement>) => {
    dispatch(
      setUpdateFilterStates({
        orderBy: e.target.value,
        currentPage: 1,
      }),
    );
    updateCurrentPage();
  };
  const handleSearchChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    if (timeoutId.current) {
      clearTimeout(timeoutId.current);
    }
    timeoutId.current = setTimeout(() => {
      updateCurrentPage();
      dispatch(setUpdateFilterStates({ currentPage: 1 }));
      setPageStates((prevState) => ({
        ...prevState,
        searchQuery: value,
      }));
    }, 500);
  };
  const handleChangePageSize = (value: number) => {
    console.log('value', value);
    dispatch(setUpdateFilterStates({ pageSize: value, currentPage: 1 }));
    updateCurrentPage();
  };
  const singleDateChangeHandler = (date: Date | null) => {
    if (!date || !moment(date).isValid()) return;

    const selectedStartDate = moment(date)
      .startOf('month')
      .format('YYYY-MM-DD');
    const selectedEndDate = moment(date).endOf('month').format('YYYY-MM-DD');
    dispatch(setDateFilter([selectedStartDate, selectedEndDate]));
  };

  return {
    handleSearchChange,
    pageChangeHandler,
    handleChangePageSize,
    orderByHandler,
    singleDateChangeHandler,
  };
};
export default useFilter;
